module.exports = __webpack_public_path__ + "img/server.8029190e.svg";